import React, { useState } from 'react'
import { Row, Col, Button, Badge } from 'antd'
import PropTypes from 'prop-types'
import { SaveOutlined, FilePdfOutlined, FileExcelOutlined, SendOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import { FirstPage } from '../../constants/Config'
const Buttons = ({ ButtonConfig, ShowCloseButton, DebouncingTime }) => {
    const [isSaveButtonClicked, setIsSaveButtonClicked] = useState(false);
    const HadleFunctionCreator = (func) => {
        if (typeof func == "undefined")
            return;
        func();
    }



    const handleSaveClick = () => {
        if (!isSaveButtonClicked) {
            setIsSaveButtonClicked(true);
            // lógica para manejar el primer clic aquí
            HadleFunctionCreator(ButtonConfig.save.HandleClick);

            setTimeout(() => {
                setIsSaveButtonClicked(false);
            }, ButtonConfig.save.debouncing ?? DebouncingTime); // 1000 es el tiempo en milisegundos para desactivar temporalmente el botón
        }
    };



    const history = useHistory()

    const CloseActionButton = () => {
        history.push(FirstPage);
        if (ButtonConfig.cancel != null) {
            ButtonConfig.cancel.HandleClick();
        }
    }

    return (
        <Row>
            <Col span={24} className="gx-text-right">



                {ButtonConfig.visualize && (<Button
                    className="gx-btn-outline-dark"
                    // icon="save"
                    style={{ marginRight: 8 }}
                    onClick={HadleFunctionCreator.bind(this, ButtonConfig.visualize.HandleClick)}
                    disabled={ButtonConfig.visualize.disabled}
                    ghost>
                    {!ButtonConfig.visualize.text ? "Visualizar" : ButtonConfig.visualize.text}

                </Button>)
                }

                {ButtonConfig.print && (<Button
                    className="gx-btn-outline-dark"
                    icon={<FilePdfOutlined />}
                    style={{ marginRight: 8 }}
                    onClick={HadleFunctionCreator.bind(this, ButtonConfig.print.HandleClick)}
                    disabled={ButtonConfig.print.disabled}
                    ghost>
                    Imprimir
                </Button>)
                }

                {ButtonConfig.email && (
                    <Badge count={ButtonConfig.email.badgeCount} offset={[-5, 5]}>
                        <Button
                            className={!ButtonConfig.email.text ? "gx-btn-outline-success" : ButtonConfig.email.className}
                            icon={!ButtonConfig.email.text ? <SendOutlined /> : null}
                            style={{ marginRight: 8 }}
                            onClick={HadleFunctionCreator.bind(this, ButtonConfig.email.HandleClick)}
                            disabled={ButtonConfig.email.disabled}
                            ghost>
                            {!ButtonConfig.email.text ? "Enviar Correo" : ButtonConfig.email.text}
                        </Button>
                    </Badge>)
                }

                {ButtonConfig.excel && (<Button
                    className="gx-btn-outline-success"
                    icon={<FileExcelOutlined />}
                    style={{ marginRight: 8 }}
                    onClick={HadleFunctionCreator.bind(this, ButtonConfig.excel.HandleClick)}
                    ghost>
                    Excel
                </Button>)
                }

                {ButtonConfig.save && (<Button
                    className="gx-btn-outline-primary"
                    icon={<SaveOutlined />}
                    style={{ marginLeft: 8, marginRight: 8, pointerEvents: (isSaveButtonClicked ? 'none' : 'all') }}
                    disabled={ButtonConfig.save.disabled || isSaveButtonClicked}
                    onClick={handleSaveClick}
                    onDoubleClick={handleSaveClick}
                    ghost>
                    {!ButtonConfig.save.text ? "Guardar" : ButtonConfig.save.text}
                </Button>)
                }
                {
                    ButtonConfig.cancel && (<Button
                        className="gx-btn-outline-danger"
                        ghost
                        style={{ marginLeft: 8, marginRight: 8 }}
                        onClick={HadleFunctionCreator.bind(this, ButtonConfig.cancel.HandleClick)} >
                        Cancelar
                    </Button>
                    )
                }

                {
                    ShowCloseButton && (
                        <Button
                            className="gx-btn-outline-warning"
                            ghost
                            type="default"
                            style={{ marginLeft: 8, marginRight: 8 }}
                            onClick={CloseActionButton} >
                            Cerrar
                        </Button>

                    )
                }
            </Col>
        </Row>
    )
}

Buttons.propTypes = {

    ButtonConfig: PropTypes.object.isRequired

}
Buttons.defaultProps = {
    ButtonConfig: {},
    ShowCloseButton: true,
    DebouncingTime: 1000
}

export default Buttons
